export class ProductViewTracker {
    tracker;
    constructor(tracker) {
        this.tracker = tracker;
    }
    trackImpression(trackingData, eventParams) {
        this.tracker.trackProductView({
            eventParams,
            listEntityType: trackingData.listEntityType,
            listName: trackingData.listName ?? '',
            listPageType: trackingData.listPageType ?? '',
            item: trackingData.getTrackingContext()
        });
    }
}
